import moment from 'moment-timezone'

export interface TimezoneHelperObject {
    name: string
    displayName: string
    offsetMinutes: number
}

export const timezones: readonly TimezoneHelperObject[] = moment.tz.names().map(name => {
    const zone = moment.tz(name)
    const offsetMinutes = zone.utcOffset()
    let offsetString = `${Math.floor(offsetMinutes / 60)}`
    if (offsetMinutes % 60 > 0) {
        offsetString += `:${offsetMinutes % 60}`
    }

    return {
        name: name,
        displayName: `${name} (UTC ${offsetMinutes >= 0 ? '+' : ''}${offsetString})`,
        offsetMinutes: offsetMinutes
    }
})

export const timezoneSuggestions = timezones.map(x => ({value: x.name, label: x.name}))

export class TimezoneHelper {
    public getTimezone(timezoneName: string): TimezoneHelperObject | undefined {
        return timezones.find(zone => zone.name === timezoneName)
    }

    public getTimezoneList(...args: string[]): readonly TimezoneHelperObject[] {
        if (args.length > 0) {
            return timezones.filter(zone => args.includes(zone.name))
        }
        return timezones
    }
}
